import React, { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import Image from "next/image";
import CounsellingImage from "../../public/counsellingImgae.webp"; // Adjust the path as necessary

export default function InstructorSection() {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true); // State to control mute/unmute

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000, // Duration of the animation in milliseconds
      once: true, // Animation will happen only once when scrolling down
    });
  }, []);

  // Toggle mute function
  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted); // Update the state based on the mute status
    }
  };

  return (
    <section
      className="instructor-section-container"
      style={{
        backgroundImage: `url(${CounsellingImage.src})` // Revert to original image for now
      }}
      data-aos="fade-up"
    >
      {/* TODO: For best performance, add optimized images and use srcSet/sizes. */}
      <Image
        src={CounsellingImage.src}
        alt="Counselling Background"
        width={1920}
        height={600}
        priority
        style={{ display: "none" }}
        sizes="(max-width: 600px) 100vw, (max-width: 1200px) 80vw, 1920px"
      />
      <div className="instructor-overlay">
        <div className="instructor-content">
          <div className="relative w-full mb-6 lg:mb-0">
            <video
              ref={videoRef}
              autoPlay
              muted={isMuted} // Set the initial mute state based on the isMuted state
              loop
              playsInline
              className="w-full h-auto cursor-pointer rounded-lg shadow-lg" // Make video clickable and responsive
              style={{fontSize: "15px", color: "#4F547B"}}
              onClick={toggleMute} // Toggle mute when clicking on video
              data-aos="zoom-in"
              data-aos-delay="300"
              loading="lazy"
            >
              <source src="https://video.gumlet.io/675008055a8822b2de770be8/675822e763a847265469d787/download.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {/* Custom Mute/Unmute Button */}
            <div
              className="absolute top-4 right-4 bg-black bg-opacity-60 p-2 rounded-full cursor-pointer text-white"
              onClick={toggleMute} // Also allow mute toggle when clicking on the icon
            >
              {isMuted ? <FaVolumeMute size={24} /> : <FaVolumeUp size={24} />}
            </div>
          </div>

          {/* Right Text Section */}
          <div
            className="instructor-text-wrapper"
            style= {{ fontSize: "15px" }}
            data-aos="fade-left"
            data-aos-delay="400"
          >
            {" "}
            {/* 600ms delay for the text */}
            <h2 className="instructor-title text-white" style={{ fontSize: "22.5px" }}>
              What is NEET Counselling?
            </h2>
            <p className="instructor-description" style={{ fontSize: "15px" }}>
              NEET Counselling is the concluding phase for candidates who have
              passed the NEET exam. It is essential in determining which medical
              institution you can enroll in, depending on your rank, your
              choices, and the availability of seats.
            </p>
            <h2
              className="instructor-title text-white"
              style={{ fontSize: "22.5px" }}
              data-aos="fade-left"
              data-aos-delay="500"
            >
              {" "}
              {/* 900ms delay for the second title */}
              Why do we Stand Out?
            </h2>
            <p
              className="instructor-description"
              style={{ fontSize: "15px" }}
              data-aos="fade-left"
              data-aos-delay="600"
            >
              {" "}
              {/* 1200ms delay for the last paragraph */}
              We are the ideal choice for you because we offer specialised counselling to help navigate the complex NEET admission process. With our advanced tools, including a Rank Predictor, College Predictor, College Rankings, Seat Matrix, and Cut-off Allotment insights, you can confidently navigate the counselling process to secure a place at the college that best fits your needs. With our resources, you can confidently obtain a place at the college that best fits your needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}


















